import React from 'react'
import { TextArea, Table, Modal, Grid, Button, Form } from 'semantic-ui-react'

import './PrefillTextModal.scss'

const { Row, Column } = Grid

class PrefillTextModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      text: '',
    }
  }
  componentWillReceiveProps(newProps) {
    const oldVisible = this.props.visible
    const { visible, field } = newProps
    if (visible && !oldVisible) this.setState({ text: field.value })
    else if (!visible) this.setState({ text: '' })
  }
  addText(newText) {
    const { text } = this.state
    this.setState({ text: `${text}${newText}` })
  }
  render() {
    const { isFemale, field, visible, onClose } = this.props
    return (
      <Modal open={visible} onClose={onClose} className="prefill-text-modal">
        <Modal.Header>Vložit předpřipravený text</Modal.Header>
        <Modal.Content>
          <Form>
            <Grid>
              <Row columns={2} className="editor-row">
                <Column size={5} className="textarea-cell">
                  <TextArea
                    name={field.name}
                    onChange={(e, event) => this.setState({ text: event.value })}
                    value={this.state.text}
                  />
                </Column>
                <Column size={11} className="table-cell">
                  <div>
                    <Table compact celled>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell rowSpan={6}>Řidič na</Table.Cell>
                          <Table.Cell>
                            <a
                              onClick={() => {
                                if (isFemale) this.addText('Řidička na slabé úrovni, ')
                                else this.addText('Řidič na slabé úrovni, ')
                              }}
                            >
                              slabé
                            </a>
                          </Table.Cell>
                          <Table.Cell rowSpan={6}>úrovni,</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => {
                                if (isFemale) this.addText('Řidička na průměrné úrovni, ')
                                else this.addText('Řidič na průměrné úrovni, ')
                              }}
                            >
                              průměrné
                            </a>
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => {
                                if (isFemale) this.addText('Řidička na slušné úrovni, ')
                                else this.addText('Řidič na slušné úrovni, ')
                              }}
                            >
                              slušné
                            </a>
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => {
                                if (isFemale) this.addText('Řidička na dobré úrovni, ')
                                else this.addText('Řidič na dobré úrovni, ')
                              }}
                            >
                              dobré
                            </a>
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => {
                                if (isFemale) this.addText('Řidička na velmi dobré úrovni, ')
                                else this.addText('Řidič na velmi dobré úrovni, ')
                              }}
                            >
                              velmi dobré
                            </a>
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => {
                                if (isFemale) this.addText('Řidička na vynikající úrovni, ')
                                else this.addText('Řidič na vynikající úrovni, ')
                              }}
                            >
                              vynikající
                            </a>
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                    <Table compact celled>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('s kratší praxí ')}
                            >
                              s kratší
                            </a>
                          </Table.Cell>
                          <Table.Cell rowSpan={2}>praxí</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('s krátkou praxí ')}
                            >
                              s krátkou
                            </a>
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                    <Table compact celled>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell rowSpan={2}>s</Table.Cell>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('s nedostatečnou úrovní znalostí pravidel provozu, ')}
                            >
                              nedostatečnou
                            </a>
                          </Table.Cell>
                          <Table.Cell rowSpan={2}>úrovní znalostí pravidel provozu,</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('s nízkou úrovní znalostí pravidel provozu, ')}
                            >
                              nízkou
                            </a>
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                    <Table compact celled>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell rowSpan={4}>s rezervami</Table.Cell>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('s rezervami v aplikaci pravidel provozu, ')}
                            >
                               v aplikaci pravidel provozu,
                            </a>
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('s rezervami v technice jízdy, ')}
                            >
                               v technice jízdy,
                            </a>
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('s rezervami v defenzivní jízdě, ')}
                            >
                               v defenzivní jízdě,
                            </a>
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('s rezervami ve všech sledovaných ukazatelích, ')}
                            >
                               ve všech sledovaných ukazatelích,
                            </a>
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                    <Table compact celled>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('dopouští se dopravních přestupků, ')}
                            >
                               dopouští se dopravních přestupků,
                            </a>
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                    <Table compact celled>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('naprosto nedodržuje rychlostní limity, ')}
                            >
                               naprosto nedodržuje rychlostní limity,
                            </a>
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                    <Table compact celled>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('se závadami v technice jízdy, ')}
                            >
                               se
                            </a>
                          </Table.Cell>
                          <Table.Cell rowSpan={2}>závadami v technice jízdy,</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('s vážnými závadami v technice jízdy, ')}
                            >
                               s vážnými
                            </a>
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                    <Table compact celled>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('s nesprávnými postoji, ')}
                            >
                               s nesprávnými postoji,
                            </a>
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                    <Table compact celled>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('za pozornost stojí vysoký počet dopravních nehod, ')}
                            >
                               za pozornost stojí vysoký počet dopravních nehod,
                            </a>
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                    <Table compact celled>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('Zdokonalovací kurz není nutný, připomínky při auditu jsou postačující. ')}
                            >
                               Zdokonalovací kurz není nutný, připomínky při auditu jsou postačující.
                            </a>
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                    <Table compact celled>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell rowSpan={4}>Dop.</Table.Cell>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('Dop. kurz aktivní bezpečné jízdy ')}
                            >
                               kurz aktivní bezpečné jízdy
                            </a>
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('Dop. kurz defenzivní jízdy ')}
                            >
                               kurz defenzivní jízdy
                            </a>
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('Dop. kurz ekonomicko ekologické jízdy ')}
                            >
                               kurz ekonomicko ekologické jízdy
                            </a>
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('Dop. individuální intervenci, zaměřenou na ')}
                            >
                               individuální intervenci, zaměřenou na,
                            </a>
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                    <Table compact celled>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('Kurzem byly odstraněny všechny závady, zjištěné při auditu. ')}
                            >
                               Kurzem byly odstraněny všechny závady, zjištěné při auditu.
                            </a>
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('Kurzem byla odstraněna většina závad, zjištěných při auditu. ')}
                            >
                               Kurzem byla odstraněna většina závad, zjištěných při auditu.
                            </a>
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('Kurzem se nepodařilo odstranit závady, zjištěné při auditu, je třeba pokračovat ve výcviku v aktivní bezpečné jízdě. ')}
                            >
                               Kurzem se nepodařilo odstranit závady, zjištěné při auditu, je třeba pokračovat ve výcviku v aktivní bezpečné jízdě.
                            </a>
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                    <Table compact celled>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell>
                            <a
                              onClick={() => this.addText('Bude provedeno opakované přezkoušení z pravidel provozu na poz. kom. ')}
                            >
                               Bude provedeno opakované přezkoušení z pravidel provozu na poz. kom.
                            </a>
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </div>
                </Column>
              </Row>
              <Row columns={1} className="actions-row">
                <Column textAlign="center">
                  <Button
                    color="red"
                    size="huge"
                    type="button"
                    onClick={() => {
                      field.onChange({ value: this.state.text })
                      onClose()
                    }}
                  >
                    Vložit
                  </Button>
                  <Button
                    basic
                    size="huge"
                    onClick={onClose}
                    type="button"
                  >
                    Zrušit změny
                  </Button>
                </Column>
              </Row>
            </Grid>
          </Form>
        </Modal.Content>
      </Modal>
    )
  }
}

PrefillTextModal.defaultProps = {
  visible: false,
  isFemale: false,
}

PrefillTextModal.propTypes = {
  isFemale: React.PropTypes.bool,
  field: React.PropTypes.object.isRequired,
  visible: React.PropTypes.bool,
  onClose: React.PropTypes.func.isRequired,
}

export default PrefillTextModal



// WEBPACK FOOTER //
// ./src/browser/components/PrefillTextModal.js